import React, { useState, useEffect } from "react";
import "./CustomBranding.css";
import hotel_image_1 from "../assets/custom_labeling/custom_new/Hotels.png";
import hotel_image_2 from "../assets/custom_labeling/restaurant_new/Hotel.png";
import restaurant_image_1 from "../assets/custom_labeling/custom_new/restaurant.png";
import restaurant_image_2 from "../assets/custom_labeling/restaurant_new/restaurant.png";
import corporate_image_1 from "../assets/custom_labeling/custom_new/Corporate_Events.png";
import corporate_image_2 from "../assets/custom_labeling/restaurant_new/corborate_event.png";
import weddings_image_1 from "../assets/custom_labeling/custom_new/Weddings.png";
import weddings_image_2 from "../assets/custom_labeling/restaurant_new/Happy_wedding.png";
import birthdays_image_1 from "../assets/custom_labeling/custom_new/Birthday.png";
import birthdays_image_2 from "../assets/custom_labeling/restaurant_new/birthday_party.png";

const categories = [
  {
    title: "Hotels",
    description: "Upgrade your guest’s experiences through premium, custom-branded water bottles designed specially for luxury hotel resorts. Personalized labelling on water bottles such as your hotel’s name reflects your brand’s sophistication and commitment to excellence.",
    images: [hotel_image_2 ,hotel_image_2],
    link: "#hotels"
  },
  {
    title: "Restaurants",
    description: "Enhance your restaurant branding through customized water bottles leaving a memorable impact. Serve high-quality, private-label bottled water matching your brand to complete the dining experience and adding a more elegant touch.",
    images: [restaurant_image_2 , restaurant_image_2],
    link: "#restaurants"
  },
  {
    title: "Corporate Events",
    description: "Make your professional gatherings more unified with custom-branded water bottles featuring your company’s logo. Whether it’s a conference, a seminar, or a business trip, reinforce your brand’s identity while keeping the employees/attendees refreshed.",
    images: [corporate_image_2 , corporate_image_2],
    link: "#corporate-events"
  },
  {
    title: "Weddings",
    description: "Add a personal touch to your special day with elegantly designed, custom-labeled water bottles. A perfect way to keep guests hydrated while complementing your wedding theme with beautifully branded bottles. Add a personalized touch to your special day with custom-labeled water bottles. Lusora serves as a perfect way to keep guests hydrated while complementing your wedding themes/ your personalized hashtags.",
    images: [weddings_image_2 , weddings_image_2],
    link: "#weddings"
  },
  {
    title: "Birthdays & Celebrations",
    description: "Make every celebration unique with customized water bottles featuring the name, date, or theme of your birthday party or special occasion. A fun and practical addition to any event!",
    images: [birthdays_image_2 , birthdays_image_2],
    link: "#birthdays"
  },
];

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000); // Change image every 8 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="image-slider">
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt="branding showcase"
          className={index === currentIndex ? "active" : "hidden"}
        />
      ))}
    </div>
  );
};

const CustomBranding = () => {
  const handleQuoteRequest = () => {
    const message = encodeURIComponent("Hello, I would like to request a quote for custom branded water bottles.");
    window.open(`https://wa.me/9829326555?text=${message}`, "_blank");
  };

  return (
    <section className="custom-branding-section" id="custom-branding">
      <div className="container">
        <h2 className="branding-title">CUSTOM BRANDING & PRIVATE LABELING</h2>
        <p className="branding-subtitle">Your Brand, Your Label, Our Water</p>
        {categories.map((category, index) => (
          <div key={index} className={`branding-content ${index % 2 !== 0 ? "reverse" : ""}`}>
            <div className="branding-text">
              <h3>{category.title}</h3>
              <p>{category.description}</p>
            </div>
            <div className="branding-image">
              <ImageSlider images={category.images} />
            </div>
          </div>
        ))}
        <button className="request-quote" onClick={handleQuoteRequest}>Request a Quote</button>
      </div>
    </section>
  );
};

export default CustomBranding;